<template>
  <div class="compare-countries-regions-nav">

    <attribute-nav
      class="compare-countries-regions-nav__attributes"
      :selectMultiple="false"
      :closeOnSelect="true"
      :toggleable="true"
      :closed="(currentNav !== 'attribute')"
      :class="{ isOpen: (currentNav === 'attribute') }"
      @toggleClosed="toggleAttributeNavigation"
    ></attribute-nav>

    <countries-nav
      class="compare-countries-regions-nav__countries"
      :selectMultiple="true"
      :closeOnSelect="false"
      :countries="countries"
      :toggleable="true"
      :closed="(currentNav !== 'country')"
      :class="{ isOpen: (currentNav === 'country') }"
      @toggleClosed="toggleCountryNavigation"
    ></countries-nav>

  </div><!-- /.compare-countries-regions-nav -->
</template>

<script>
import AttributeNav from './../AttributesNavigation/Nav'
import CountriesNav from './../CountriesNavigation/Nav'

export default {
  name: 'compare-countries-regions-navigation',
  components: {
    'attribute-nav': AttributeNav,
    'countries-nav': CountriesNav
  },
  data () {
    return {
      currentNav: 'attribute'
    }
  },
  computed: {
    countries () { return this.$store.state.rsc.all },
    selectedCountries () { return this.$store.state.rsc.selected },
    selectedAttributes () { return this.$store.state.attributes.selected }
  },
  watch: {
    selectedAttributes () {
      if (this.selectedAttributes.length > 0) {
        this.currentNav = 'country'
      }
    }
  },
  mounted () {
    if (this.selectedAttributes.length > 0) {
      this.currentNav = 'country'
    }
  },
  methods: {
    toggleCountryNavigation (closed) {
      if (closed) {
        this.currentNav = 'attribute'
      } else {
        this.currentNav = 'country'
      }
    },
    toggleAttributeNavigation (closed) {
      if (closed) {
        this.currentNav = 'country'
      } else {
        this.currentNav = 'attribute'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.compare-countries-regions-nav{
  display: flex; -js-display: flex;
  flex-direction: column;
  height: 100%;

  > *{
    flex: 0 1 auto;
  }
  > *.isOpen{
    flex: 0 1 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/PageSidebarNavigation/CompareCountriesRegions.vue